import { useEffect } from 'react';
import { Backdrop } from '../components/Backdrop';
import { AuthScreen } from '../screens/AuthScreen';
import { CharacterCreateScreen } from '../screens/CharacterCreateScreen';
import { CharacterSelectScreen } from '../screens/CharacterSelectScreen';
import { GameScreen } from '../screens/GameScreen';
import { LoadingScreen } from '../screens/LoadingScreen';
import { MenuScreen } from '../screens/MenuScreen';
import { RealmScreen } from '../screens/RealmScreen';
import { api, ApiError } from '../services/api';
import { audio } from '../game/audio/audio';
import { useSession } from '../stores/session-store';

export function App() {
  const screen = useSession((s) => s.screen);

  useEffect(() => {
    // Restore an existing session cookie, if any.
    api
      .me()
      .then((r) => {
        useSession.getState().setUser(r.user);
        useSession.getState().go('menu');
      })
      .catch((err: unknown) => {
        if (!(err instanceof ApiError) || err.status !== 401) console.warn(err);
        useSession.getState().go('auth');
      });
    // Browsers only allow audio after a user gesture.
    const unlock = (): void => audio.unlock();
    window.addEventListener('pointerdown', unlock, { once: true });
    window.addEventListener('keydown', unlock, { once: true });
    return () => {
      window.removeEventListener('pointerdown', unlock);
      window.removeEventListener('keydown', unlock);
    };
  }, []);

  if (screen === 'game') return <GameScreen />;
  return (
    <>
      <Backdrop />
      {screen === 'loading' && <LoadingScreen />}
      {screen === 'auth' && <AuthScreen />}
      {screen === 'menu' && <MenuScreen />}
      {screen === 'realms' && <RealmScreen />}
      {screen === 'characters' && <CharacterSelectScreen />}
      {screen === 'create' && <CharacterCreateScreen />}
    </>
  );
}
